module.exports = __webpack_public_path__ + "img/vertical_mid_frame.51e1bbec.png";